<script src="./BaseDate.js"></script>

<template>
  <span>
    {{ formattedDate }}
  </span>

</template>
